import { CHAT_WIDGET_AVATAR_SPEECH_STALLED } from '@/lib/analytics-events';

export const STALL_TOLERANCE_MS = 1500;

export interface AvatarSpeechStallTracker {
  schedule: (chunkIndex: number) => void;
  clear: () => void;
  dispose: () => void;
  getStallCount: () => number;
}

export function createAvatarSpeechStallTracker(opts: {
  track: (event: string, props: Record<string, unknown>) => void;
  institutionId: string;
  sessionId: string;
  messageId: string;
  isStreamOpen: () => boolean;
  isSpeechStarted: () => boolean;
}): AvatarSpeechStallTracker {
  let stallCount = 0;
  let stallTimer: ReturnType<typeof setTimeout> | null = null;
  let stallStartedAt: number | undefined;

  const clear = () => {
    if (stallTimer) {
      clearTimeout(stallTimer);
      stallTimer = null;
    }
    stallStartedAt = undefined;
  };

  const schedule = (chunkIndex: number) => {
    clear();
    if (!opts.isStreamOpen() || !opts.isSpeechStarted()) return;
    stallStartedAt = Date.now();
    stallTimer = setTimeout(() => {
      stallTimer = null;
      if (!opts.isStreamOpen()) return;
      stallCount += 1;
      opts.track(CHAT_WIDGET_AVATAR_SPEECH_STALLED, {
        institutionId: opts.institutionId,
        sessionId: opts.sessionId,
        messageId: opts.messageId,
        chunkIndex,
        stallDurationMs: stallStartedAt ? Date.now() - stallStartedAt : STALL_TOLERANCE_MS,
      });
      stallStartedAt = undefined;
    }, STALL_TOLERANCE_MS);
  };

  return {
    schedule,
    clear,
    dispose: () => {
      clear();
    },
    getStallCount: () => stallCount,
  };
}
